import React, { Component } from 'react'
import UserItem from './UserItem';

export default class NotificationUserList extends Component {

    constructor(props){
        super(props);
        this.state = {};
    }

    render() {
        let items = [];
        this.props.users.forEach((item) => {
            items.push(<UserItem onToggleReceiver={this.props.onToggleReceiver} login={item.login} key={item.nameWithLogin} onlineStatus={item.onlineStatus} nameWithLogin={item.nameWithLogin} type={item.type}/>)
        });
        return (
            <div className={this.props.className}>
                <div style={{fontSize: 17, color: 'black', textAlign: 'center', fontWeight: 'bold', marginBottom: 5}}>
                    {this.props.title}
                </div>
                {items}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/notifictions/NotificationUserList.js